import { z } from "zod"

export const ContactAlternativeSchema = z.object({
  id: z.number(),
  contact_id: z.number(),
  type: z.number(),
  type_name: z.string(),
  name: z.string().nullable(),
  role: z.string().nullable(),
  phone_number: z.string().nullable(),
  email: z.string().nullable(),
})

export const ContactSchema = z.object({
  id: z.number(),
  type: z.number(),
  type_name: z.string(),
  name: z.string(),
  nif: z.string().nullable(),
  phone_number: z.string().nullable(),
  mobile_number: z.number().nullable(),
  email: z.string().nullable(),
  address: z.string().nullable(),
  postal_code: z.string().nullable(),
  contact_person: z.string().nullable(),
  locale: z.string().nullable(),
  email_alternative: z.string().nullable(),
  website: z.string().nullable(),
  alternative_contacts: z.array(ContactAlternativeSchema),
})

export const ContactFormSchema = z.object({
  type: z.number(),
  name: z.string().min(1),
  nif: z.string().nullable().default(null),
  address: z.string().nullable().default(null),
  postal_code: z.string().nullable().default(null),
  phone_number: z.string().nullable().default(null),
  mobile_number: z.number().nullable().default(null),
  contact_person: z.string().nullable().default(null),
  locale: z.string().nullable().default(null),
  email: z.string().nullable().default(null),
  email_alternative: z.string().nullable().default(null),
  website: z.string().nullable().default(null),
})

export const ContactAlternativeFormSchema = z.object({
  contact_id: z.number(),
  type: z.number(),
  name: z.string().nullable().default(null),
  role: z.string().nullable().default(null),
  phone_number: z.string().nullable().default(null),
  email: z.string().nullable().default(null),
})

export type Contact = z.infer<typeof ContactSchema>
export type ContactFormValues = z.infer<typeof ContactFormSchema>
export type ContactAlternative = z.infer<typeof ContactAlternativeSchema>
export type ContactAlternativeFormValues = z.infer<typeof ContactAlternativeFormSchema>
